import React, { useCallback } from "react";
import { BackButton, CompareButton } from "../StdButton";
import { useHistory } from "react-router-dom";
import { buildUri, ROUTE, WaterProvider } from "../misc";
import { useProviderInfoPageContext } from "../../Components/Context";
import { LoadingIndicator } from "../../Components/LoadingIndicator";
import { event as backToSearchEvent } from "../GA/ProviderInfo/BackToSearch";
import { event as compareToAnotherProvider } from "../GA/ProviderInfo/CompareToAnotherProvider";

interface ProviderInfoNavProps {
    provider?: WaterProvider;
    toProvider?: WaterProvider;
    loading?: boolean;
    onCompareButtonClick?: () => void;
    onBackToSearch?: () => void;
}

export const ProviderInfoNav: React.FC<ProviderInfoNavProps> = ({
    provider,
    toProvider,
    onBackToSearch,
    onCompareButtonClick,
    loading
}) => {
    const history = useHistory();
    return (
        <div className="triple-margin-bottom col-12">
            <div className="row">
                <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center default-margin-bottom">
                    <BackButton
                        onClick={() => {
                            history.push(`${ROUTE.SEARCH_PAGE}`);
                            onBackToSearch != null && onBackToSearch();
                        }}
                    ></BackButton>
                </div>
                <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center default-margin-bottom">
                    {(loading === false || loading == null) && provider != null && (
                        // provider.connectionSizeCategory !== PROVIDER_CONNECTION_TYPE.bulk
                        <CompareButton
                            onClick={() => {
                                history.push(
                                    buildUri(
                                        ROUTE.PROVIDER_SELECT_TO_COMPARE,
                                        {},
                                        {
                                            ...(provider?.adminId != null && provider?.adminId.trim() !== ""
                                                ? {
                                                      from: provider?.adminId
                                                  }
                                                : {}),

                                            ...(toProvider?.adminId != null && toProvider?.adminId.trim() !== ""
                                                ? {
                                                      to: toProvider?.adminId
                                                  }
                                                : {})
                                        }
                                    )
                                );

                                onCompareButtonClick != null && onCompareButtonClick();
                            }}
                        ></CompareButton>
                    )}
                    {loading === true && <LoadingIndicator />}

                    {(loading === false || loading == null) && !provider && <></>}
                </div>
            </div>
        </div>
    );
};

export const ProviderInfoNavWithContext = () => {
    const { loading, provider } = useProviderInfoPageContext();
    const onCompareButtonClick = useCallback(() => {
        compareToAnotherProvider("providerInfo", provider?.name);
    }, [provider]);

    const onBackToSearch = useCallback(() => {
        backToSearchEvent("providerInfo");
    }, []);

    return (
        <ProviderInfoNav
            provider={provider}
            loading={loading}
            onCompareButtonClick={onCompareButtonClick}
            onBackToSearch={onBackToSearch}
        />
    );
};
